import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolveReleaseStatus } from '@/lib/domain';

export interface ReleaseStatusPillProps {
  status: string | null | undefined;
  scheduleId?: string;
}

export const ReleaseStatusPill = ({ status, scheduleId }: ReleaseStatusPillProps) => {
  const { t } = useTranslation('settlement');
  const meta = resolveReleaseStatus(status, scheduleId ? { scheduleId } : undefined);
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={status}
      label={t(meta.i18nKey, status ?? '')}
      testId="release-status-pill"
    />
  );
};
